import { Component, OnInit,ElementRef, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-service',
  templateUrl: './service.component.html',
  styleUrls: ['./service.component.css']
})
export class ServiceComponent implements OnInit {

  constructor(private elementRef: ElementRef,@Inject(DOCUMENT) private doc) { }

  ngOnInit() {

    // let link3: HTMLLinkElement = this.doc.createElement('link');
    // link3.setAttribute('rel', 'stylesheet');
    // link3.setAttribute('type', 'text/html');
    // link3.setAttribute('href', '../assets/css/magnific-popup.min.css');
    // this.doc.head.appendChild(link3);
    

    
    // var s3 = document.createElement("script");
    // s3.type = "text/javascript";
    // s3.src = "../assets/js/jquery-3.3.1.min.js";
    // this.elementRef.nativeElement.appendChild(s3);
    // var s4 = document.createElement("script");
    // s4.type = "text/javascript";
    // s4.src = "../assets/js/jquery.magnific-popup.min.js";
    // this.elementRef.nativeElement.appendChild(s4);
    var s5 = document.createElement("script");
    s5.type = "text/javascript";
    s5.src = "../assets/js/new.js";
    this.elementRef.nativeElement.appendChild(s5);


  }

}
